import React from 'react'

const ChevronUp = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z M0 0h24v24H0z" />
  </svg>
)

export default ChevronUp
